import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class Field extends Component {
  static propTypes = {
    icon: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.string,
    field: PropTypes.element,
  };

  render() {
    return (
      <div className="AddActions-Field">
        <div className="AddActions-Field-content">
          <div className="AddActions-Field-text">
            <label>{this.props.text}</label>
          </div>
          <div className="AddActions-Field-field">{this.props.field}</div>
          {this.props.removeAction ? (
            <div
              className="AddActions-Field-remove"
              onClick={this.props.removeAction}
            >
              <i className="far fa-trash-alt"></i>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Field;
